var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLessonLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.784 8.18373V5.60697C13.784 2.51516 11.1894 0 8 0C4.81055 0 2.21597 2.51516 2.21597 5.60697V8.18373C0.96878 8.33271 0 9.36374 0 10.6122V17.551C0 18.9016 1.13307 20 2.52632 20H13.4737C14.8669 20 16 18.9016 16 17.551V10.6122C16 9.3637 15.0307 8.33263 13.784 8.18373ZM8.81089 14.1092C8.82896 14.1761 8.84203 14.2451 8.84203 14.3173V16.7347C8.84203 17.1853 8.46475 17.5511 7.99993 17.5511C7.53511 17.5511 7.15782 17.1853 7.15782 16.7347V14.3173C7.15782 14.2451 7.17045 14.1761 7.18896 14.1092C6.66142 13.8292 6.29965 13.2928 6.29965 12.6688C6.29965 11.7586 7.06087 11.0206 7.99983 11.0206C8.93879 11.0206 9.70001 11.7586 9.70001 12.6688C9.70001 13.2928 9.3379 13.8292 8.8107 14.1092H8.81089ZM11.2577 8.16348H4.74229V5.60718C4.74229 3.86595 6.20378 2.4492 8 2.4492C9.79622 2.4492 11.2577 3.86595 11.2577 5.60718V8.16348Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonLocked);
export default __webpack_public_path__ + "static/media/lessonLocked.071fe288b3c2c3a57b29e9c021d5df7f.svg";
export { ForwardRef as ReactComponent };